// https://github.com/vercel/swr/blob/master/examples/axios-typescript/libs/useRequest.ts
// import useSWR, { SWRConfiguration, SWRResponse } from 'swr'
// import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import useSWR from 'swr'
import axios from 'axios'

// export type GetRequest = AxiosRequestConfig | null

// interface Return<Data, Error>
//   extends Pick<
//     SWRResponse<AxiosResponse<Data>, AxiosError<Error>>,
//     'isValidating' | 'error' | 'mutate'
//   > {
//   data: Data | undefined
//   response: AxiosResponse<Data> | undefined
// }

// export interface Config<Data = unknown, Error = unknown>
//   extends Omit<
//     SWRConfiguration<AxiosResponse<Data>, AxiosError<Error>>,
//     'fallbackData'
//   > {
//   fallbackData?: Data
// }

const defaultConfig = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  errorRetryCount: 0,
}

//export function getApiPath(url: string): string {
export function getApiPath(url) {

  const apiLocation = window.location.origin;


  if (url.startsWith('/')) {

    return apiLocation + url;

  }

  return apiLocation + '/' + url;

}

// export default function useRequest<Data = unknown, Error = unknown>(
//   request: GetRequest,
//   { fallbackData, ...config }: Config<Data, Error> = {}
// ): Return<Data, Error> {
export default function useRequest(
  request,
  { fallbackData, ...config } = {}
) {
  if (request) request.url = getApiPath(request.url ?? "");
  const {
    data: response,
    error,
    isValidating,
    mutate
    // } = useSWR<AxiosResponse<Data>, AxiosError<Error>>(
  } = useSWR(
    request && JSON.stringify(request),
    /**
     * NOTE: Typescript thinks `request` can be `null` here, but the fetcher
     * function is actually only called by `useSWR` when it isn't.
     */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // () => axios.request<Data>(request!),
    () => axios.request(request),
    {
      ...{ ...defaultConfig, ...config },
      fallbackData: fallbackData && {
        status: 200,
        statusText: 'InitialData',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        // config: request!,
        config: request,
        headers: {},
        data: fallbackData
      }
    }
  )

  return {
    data: response && response.data,
    response,
    error,
    isValidating,
    mutate
  }
}
